module.exports = __webpack_public_path__ + "static/media/sidebarIcon_home.ef423cf6.svg";